var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1619_2089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46 0V2.04L7.14 2.72V0.68H12.24V4.76H16.32V13.6H11.22V14.28H17V4.28188L12.7181 0H6.46ZM12.92 1.15813L15.8419 4.08H12.92V1.15813ZM0 2.72V17H10.54V7.00187L10.4444 6.89563L6.36438 2.81562L6.25812 2.72H0ZM0.68 3.4H5.78V7.48H9.86V16.32H0.68V3.4ZM6.46 3.88875L9.37125 6.8H6.46V3.88875Z",
    fill: "#29CC8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1619_2089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.33028d8108dc9c0fbc39ce589a73ddc0.svg";
export { ForwardRef as ReactComponent };